import { render, staticRenderFns } from "./AddPointsSystemMessage.vue?vue&type=template&id=802ae628&scoped=true&"
import script from "./AddPointsSystemMessage.vue?vue&type=script&lang=js&"
export * from "./AddPointsSystemMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802ae628",
  null
  
)

export default component.exports